export const GOOGLE_PLACES_API_KEY =
  process.env.REACT_APP_GOOGLE_PLACES_API_KEY ||
  process.env.REACT_PUBLIC_GOOGLE_PLACES_API_KEY ||
  process.env.REACT_APP_GOOGLE_CIVIC_API_KEY ||
  "";

export const ADDRESS_PRIMARY = "#047857";
export const ADDRESS_PRIMARY_HOVER = "#065f46";

export function parseAddressComponents(details) {
  if (!details?.address_components) return null;
  let streetNumber = "";
  let route = "";
  let city = "";
  let state = "";
  let zipcode = "";
  details.address_components.forEach((component) => {
    const types = component.types || [];
    if (types.includes("street_number")) streetNumber = component.long_name;
    else if (types.includes("route")) route = component.long_name;
    else if (
      (types.includes("locality") ||
        types.includes("sublocality") ||
        types.includes("neighborhood")) &&
      !city
    ) {
      city = component.long_name;
    } else if (types.includes("administrative_area_level_1")) {
      state = component.short_name;
    } else if (types.includes("postal_code")) {
      zipcode = component.long_name;
    }
  });
  return {
    street_1: streetNumber && route ? `${streetNumber} ${route}` : route || streetNumber,
    city,
    state,
    zipcode,
  };
}

export function addressFromInitial(initialAddress) {
  return {
    street_1: initialAddress?.street_1 || "",
    city: initialAddress?.city || "",
    state: initialAddress?.state || "",
    zipcode: initialAddress?.zipcode || "",
  };
}
